import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ToastController, LoadingController, AlertController } from '@ionic/angular';
import { BaseClass } from 'src/app/shared/classes/base';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { Note } from '../_interfaces/note.interface';
import { NotepadService } from '../notepad.service';
import { UserItem } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-user-notes',
  templateUrl: './user-notes.component.html',
  styleUrls: [ '../notepad.page.scss' ]
})
export class UserNotesComponent extends BaseClass {

  @Input() currentUser: UserItem;
  @Input() notes: Array<Note>;

  @Output() reloadNotes = new EventEmitter();

  public currentSegment: string = 'user';
  public currentNote: Note = new Note('');

  constructor(
    protected _toastController: ToastController,
    protected _translationService: TranslationService,
    private _loadingController: LoadingController,
    private _alertController: AlertController,
    private _notepadService: NotepadService
  ) {
    super(_toastController, _translationService);
  }

  public setNewNote(): void {
    this.currentNote = new Note('');
  }

  public saveNote(note: Note) {
    note.id ?
      this._updateNote( note ) :
      this._addNote( note.text );
  }

  private async _addNote(text: string): Promise<void> {
    const loading = await this._loadingController.create();
    await loading.present();

    this._notepadService.addNote(
      text
    ).subscribe(() => {
      this.currentNote = new Note('');
      loading.dismiss();

      this.notifySuccess();
      this.reloadNotes.emit();

    }, (error) => {
      loading.dismiss();
      this.notifyError(error);
    });
  }

  private async _updateNote(note: Note): Promise<void> {
    const loading = await this._loadingController.create();
    await loading.present();

    this._notepadService.updateNote(
      note
    ).subscribe(() => {
      this.currentNote = new Note('');
      loading.dismiss();

      this.notifySuccess();
      this.reloadNotes.emit();

    }, (error) => {
      loading.dismiss();
      this.notifyError(error);
    });
  }

  public async confirmDeleteNote(noteId: number): Promise<void> {
    const alert = await this._alertController.create({
      message: this._translationService.getTranslation('notepad.confirmDeleteNote'),
      buttons: [{
        text: this._translationService.getTranslation('generic.no'),
        role: 'cancel',
        cssClass: 'danger'
      }, {
        text: this._translationService.getTranslation('generic.yes'),
        handler: () => {
          this._deleteNote(noteId);
        }
      }]
    });

    await alert.present();
  }

  private _deleteNote(noteId: number): void {
    this._notepadService.deleteNote(
      noteId
    ).subscribe(() => {
      this.notifySuccess();
      this.reloadNotes.emit();

    }, (error) => this.notifyError(error) );
  }

}
